/**
 * Replace every mention of `target` in `text`, except where the mention sits
 * inside a longer sibling phrase — "ibuprofen 200" inside "ibuprofen 200 XR"
 * belongs to the other medication and must not be rewritten with it.
 * Matching ignores case: the same name is capitalized at a sentence start.
 */
export function replaceMentions(
  text: string,
  target: string,
  replacement: string,
  siblings: readonly string[],
): string {
  const haystack = text.toLowerCase()
  const needle = target.toLowerCase()
  if (!needle) return text
  const shields = siblings
    .map((s) => s.toLowerCase())
    .filter((s) => s.length > needle.length && s.includes(needle))
  const shielded = (at: number) =>
    shields.some((s) => {
      for (let i = haystack.indexOf(s); i !== -1; i = haystack.indexOf(s, i + 1)) {
        if (at >= i && at + needle.length <= i + s.length) return true
      }
      return false
    })
  let out = ''
  let cursor = 0
  for (
    let at = haystack.indexOf(needle);
    at !== -1;
    at = haystack.indexOf(needle, at + needle.length)
  ) {
    if (shielded(at)) continue
    out += text.slice(cursor, at) + replacement
    cursor = at + needle.length
  }
  return out + text.slice(cursor)
}
